export const runWithRetry = async <T>(
  fn: () => Promise<T>,
  maxRetries: number,
): Promise<T> => {
  let attemptsLeft = maxRetries

  while (true) {
    try {
      return await fn()
    } catch (error) {
      if (attemptsLeft > 1) {
        attemptsLeft--
        continue
      }
      throw new Error(`Operation failed after ${maxRetries} retries`, {
        cause: error,
      })
    }
  }
}
